// Trigger a browser file download from an in-memory Blob.
//
// Pattern: create a temporary object URL, attach it to a hidden <a download>,
// click it, then revoke the URL on the next tick so Safari/Firefox have
// time to read it. SSR-safe (no-op if document is unavailable).

export function triggerDownload(blob: Blob, filename: string): void {
  if (typeof document === "undefined" || typeof window === "undefined") return;
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = filename;
  // Some browsers ignore the download attribute unless the anchor is in the
  // DOM. Append/remove around the synthetic click to be safe.
  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);
  // Defer revocation: WebKit reads the URL on the microtask after click().
  setTimeout(() => URL.revokeObjectURL(url), 0);
}
